import { render, staticRenderFns } from "./scarReckoner.vue?vue&type=template&id=65884122&scoped=true&"
import script from "./scarReckoner.vue?vue&type=script&lang=js&"
export * from "./scarReckoner.vue?vue&type=script&lang=js&"
import style0 from "./scarReckoner.vue?vue&type=style&index=0&id=65884122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65884122",
  null
  
)

export default component.exports